<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <h3>{{ $t('jihuadanhao') }}：{{ this.$attrs.bomWork.no }}</h3>
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/plan/bom/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <!--				<el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')"  @click="exportExcel()"></el-button>-->
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button v-if="$attrs.bomWork.status == 1" type="text" @click="yt.showEditDialog('xiugaixuqiuliang', scope.row, 'w2')">
              {{ $t('xiugaixuqiuliang') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog v-dialog-drag :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 需求量 -->
      <template v-if="yt.editObj.action == 'xiugaixuqiuliang'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('xiuqiuliang')" required="required">
            <el-input v-model="yt.editObj.quantity"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/production/wobom/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
// import work_bom from '@@/pages/web/order_management/erp/work_bom'
export default {
  name: 'web_production_management_work_order_execution_bom',
  components: {
    // work_bom
  },
  data() {
    return {
      orderNo: '123',
      columns: [
        {
          label: 'wuliaobianma',
          prop: 'material.code',
          width: 130
        },
        {
          label: 'wuliaomingcheng',
          prop: 'material.name',
          width: 130
        },
        {
          label: 'shuliang',
          prop: 'quantity'
        },
        {
          label: 'danwei',
          prop: 'unit'
        },
        {
          label: 'kucunzuzhi',
          prop: 'inventoryOrg'
        },
        {
          label: 'shengchanyongliaoqingdanbianhao',
          prop: 'productionMaterialListNo'
        },
        {
          label: 'beizhu',
          prop: 'remark'
        }
      ]
    };
  },

  created() {
    setTimeout(() => {
      this.yt.conditions = {
        planId: this.$attrs.bomWork.id
      };
      this.yt.get(1);
    }, 300);
  },
  methods: {}
};
</script>
